var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"nav-svg-icon icon-expand pointer w-22",on:{"click":function($event){return _vm.$emit('showExpandedDialog')}}})}
var staticRenderFns = []

export { render, staticRenderFns }